import {
  readSessionStorageJson,
  removeSessionStorageValue,
  SERVICE_FLOW_STORAGE_KEYS,
} from '../storage';

export class RemoveItemsDialog {
  constructor(element) {
    element.RemoveItemsDialog = this;
    this._el = element;
    this._confirmHref = null;

    this._titleEl = element.querySelector('[data-remove-items-dialog-title]');
    this._bodyEl = element.querySelector('[data-remove-items-dialog-body]');
    this._titleTemplate = this._titleEl?.textContent.trim() || '';
    this._bodyTemplate = this._bodyEl?.textContent.trim() || '';

    const closeBtn = element.querySelector('[data-remove-items-dialog-close]');
    const cancelBtn = element.querySelector('[data-remove-items-dialog-cancel]');
    const confirmBtn = element.querySelector('[data-remove-items-dialog-confirm]');
    this._controls = { closeBtn, cancelBtn, confirmBtn };
    this._isLoading = false;

    element
      .querySelector('[data-remove-items-dialog-close]')
      ?.addEventListener('click', () => this.close());
    cancelBtn?.addEventListener('click', () => this.close());
    confirmBtn?.addEventListener('click', () => {
      if (this._isLoading || !this._confirmHref) return;

      this._setLoading(true);
      removeSessionStorageValue(SERVICE_FLOW_STORAGE_KEYS.ITEMS);
      window.location.replace(this._confirmHref);
    });

    this._el.addEventListener('cancel', (e) => {
      if (this._isLoading) e.preventDefault();
    });

    this._el.addEventListener('click', (e) => {
      if (e.target === this._el) this.close();
    });

    document.addEventListener('remove-items-dialog:open', (e) => this.open(e.detail));
  }

  open({ count, href } = {}) {
    this._confirmHref = href || null;
    const itemsCount = this._getItemsCount(count);

    if (itemsCount !== undefined) {
      if (this._titleEl && this._titleTemplate) {
        this._titleEl.textContent = this._replaceItemsCount(this._titleTemplate, itemsCount);
      }
      if (this._bodyEl && this._bodyTemplate) {
        this._bodyEl.textContent = this._replaceItemsCount(this._bodyTemplate, itemsCount);
      }
    }
    this._setLoading(false);
    this._el.showModal();
  }

  _getItemsCount(fallbackCount) {
    const items = readSessionStorageJson(SERVICE_FLOW_STORAGE_KEYS.ITEMS);

    if (Array.isArray(items)) {
      return items.length;
    }

    return fallbackCount;
  }

  _replaceItemsCount(template, itemsCount) {
    const count = String(itemsCount);

    return template
      .replace(/\$\{\{itemsCount\}\}/g, count)
      .replace(/\$\{itemsCount\}/g, count)
      .replace(/\{itemsCount\}/g, count)
      .replace(/\{count\}/g, count);
  }

  close() {
    if (this._isLoading) return;
    this._el.close();
  }

  _setLoading(isLoading) {
    this._isLoading = isLoading;
    this._el.classList.toggle('remove-items-dialog--loading', isLoading);
    this._el.setAttribute('aria-busy', String(isLoading));

    Object.values(this._controls).forEach((control) => {
      if (control) control.disabled = isLoading;
    });

    if (this._controls.confirmBtn) {
      this._controls.confirmBtn.setAttribute('aria-busy', String(isLoading));
    }
  }
}
